// // // import { useState } from "react";
// // // import { motion, AnimatePresence } from "framer-motion";
// // // import { ChevronLeft, ChevronRight } from "lucide-react";

// // // const milestones = [
// // //   {
// // //     year: "1920",
// // //     title: "Maiden Conference",
// // //     desc: "ASSOCHAM's maiden conference held at Royal Exchange, Calcutta.",
// // //   },
// // //   {
// // //     year: "1921",
// // //     title: "First Annual Report",
// // //     desc: "First annual report signed at Royal Exchange, Calcutta. Name changed from the Association of Chambers of Commerce of India and Ceylon to the Associated Chambers of Commerce of India and Ceylon.",
// // //   },
// // //   {
// // //     year: "1922",
// // //     title: "PHD Joins",
// // //     desc: "PHD Chamber of Commerce and Industry joins ASSOCHAM.",
// // //   },
// // //   {
// // //     year: "1934",
// // //     title: "Central Fund",
// // //     desc: "Central fund created for a European Commercial Representative for ASSOCHAM.",
// // //   },
// // //   {
// // //     year: "1942",
// // //     title: "Progress Commitment",
// // //     desc: "ASSOCHAM states the desire of the British Community in India to continue to assist in the progress of agriculture and the industry.",
// // //   },
// // //   {
// // //     year: "1949",
// // //     title: "Managing Agency Debate",
// // //     desc: "ASSOCHAM debates on Managing Agency System.",
// // //   },
// // //   {
// // //     year: "1964",
// // //     title: "New Identity",
// // //     desc: "Name changed to Associated Chambers of Commerce and Industry of India.",
// // //   },
// // //   {
// // //     year: "1965",
// // //     title: "Nation First",
// // //     desc: "ASSOCHAM ploughs four acres of land of each family holding free of charge in Punjab's Khem Karan town, devastated by Indo-Pak war.",
// // //   },
// // //   {
// // //     year: "1968",
// // //     title: "Indian Leadership",
// // //     desc: "First non-British president – N M Wagle assumes charge.",
// // //   },
// // //   {
// // //     year: "1972",
// // //     title: "Capital Move",
// // //     desc: "ASSOCHAM shifts base from Calcutta to Delhi.",
// // //   },
// // //   {
// // //     year: "1987",
// // //     title: "IMC Joins",
// // //     desc: "Indian Merchants' Chamber, Bombay joins ASSOCHAM.",
// // //   },
// // //   {
// // //     year: "1998",
// // //     title: "JRD Memorial Lectures",
// // //     desc: "JRD Memorial Lectures launched in honour of industrial legend J.R.D. Tata.",
// // //   },
// // //   {
// // //     year: "2006",
// // //     title: "Global Footprint",
// // //     desc: "First overseas office set up in China.",
// // //   },
// // //   {
// // //     year: "2013",
// // //     title: "New Headquarters",
// // //     desc: "ASSOCHAM moves to office at Chanakyapuri in New Delhi.",
// // //   },
// // //   {
// // //     year: "2020",
// // //     title: "Centenary",
// // //     desc: "Celebrated 100 years of journey — a century of nation-building.",
// // //   },
// // // ];

// // // export default function Milestones() {
// // //   const [active, setActive] = useState(0);
// // //   const [direction, setDirection] = useState(0);

// // //   const goTo = (index) => {
// // //     setDirection(index > active ? 1 : -1);
// // //     setActive(index);
// // //   };

// // //   const prev = () => {
// // //     if (active > 0) goTo(active - 1);
// // //   };

// // //   const next = () => {
// // //     if (active < milestones.length - 1) goTo(active + 1);
// // //   };

// // //   const variants = {
// // //     enter: (dir) => ({ x: dir > 0 ? 80 : -80, opacity: 0 }),
// // //     center: { x: 0, opacity: 1 },
// // //     exit: (dir) => ({ x: dir > 0 ? -80 : 80, opacity: 0 }),
// // //   };

// // //   return (
// // //     <section id="milestones" className="relative overflow-hidden bg-[#1a1a1a] py-20 md:py-28">
// // //       {/* Background accents */}
// // //       <div className="pointer-events-none absolute left-1/4 top-0 h-px w-1/2 bg-gradient-to-r from-transparent via-[#DA2128]/50 to-transparent" />
// // //       <div className="pointer-events-none absolute bottom-0 right-0 h-64 w-64 rounded-full bg-[#DA2128]/10 blur-3xl" />

// // //       <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
// // //         <div className="mb-12 text-center md:mb-16">
// // //           <motion.span
// // //             initial={{ opacity: 0 }}
// // //             whileInView={{ opacity: 1 }}
// // //             viewport={{ once: true }}
// // //             className="mb-3 inline-block text-xs font-bold tracking-[0.2em] text-[#F0484E] uppercase"
// // //           >
// // //             A Journey Through Time
// // //           </motion.span>
// // //           <motion.h2
// // //             initial={{ opacity: 0, y: 20 }}
// // //             whileInView={{ opacity: 1, y: 0 }}
// // //             viewport={{ once: true }}
// // //             className="text-3xl font-bold tracking-tight text-white sm:text-4xl md:text-5xl"
// // //           >
// // //             ASSOCHAM Milestones
// // //           </motion.h2>
// // //           <div className="mx-auto mt-4 accent-bar" />
// // //           <p className="mx-auto mt-5 max-w-xl text-sm text-white/60 sm:text-base">
// // //             From Royal Exchange, Calcutta to Chanakyapuri, New Delhi — a century
// // //             of shaping India's economic destiny.
// // //           </p>
// // //         </div>

// // //         {/* Year pills - scrollable */}
// // //         <div className="mb-10 overflow-x-auto pb-2 scrollbar-thin">
// // //           <div className="flex min-w-max items-center gap-2 px-1">
// // //             {milestones.map((m, i) => (
// // //               <button
// // //                 key={m.year}
// // //                 onClick={() => goTo(i)}
// // //                 className={`relative shrink-0 rounded-full px-4 py-2 text-xs font-bold transition-all duration-300 sm:text-sm ${
// // //                   active === i
// // //                     ? "bg-[#DA2128] text-white shadow-lg shadow-[#DA2128]/40 scale-110"
// // //                     : "bg-white/5 text-white/50 hover:bg-white/10 hover:text-white/80"
// // //                 }`}
// // //               >
// // //                 {m.year}
// // //                 {active === i && (
// // //                   <motion.div
// // //                     layoutId="year-indicator"
// // //                     className="absolute -bottom-1 left-1/2 h-1 w-1 -translate-x-1/2 rounded-full bg-white"
// // //                   />
// // //                 )}
// // //               </button>
// // //             ))}
// // //           </div>
// // //         </div>

// // //         {/* Active milestone card */}
// // //         <div className="relative mx-auto max-w-3xl">
// // //           <div className="flex items-center gap-3 sm:gap-6">
// // //             <button
// // //               onClick={prev}
// // //               disabled={active === 0}
// // //               className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white transition-all hover:bg-[#DA2128] disabled:opacity-30 disabled:hover:bg-white/5"
// // //               aria-label="Previous milestone"
// // //             >
// // //               <ChevronLeft size={20} />
// // //             </button>

// // //             <div className="relative min-h-[220px] flex-1 overflow-hidden rounded-3xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm sm:min-h-[200px] sm:p-10">
// // //               <AnimatePresence mode="wait" custom={direction}>
// // //                 <motion.div
// // //                   key={active}
// // //                   custom={direction}
// // //                   variants={variants}
// // //                   initial="enter"
// // //                   animate="center"
// // //                   exit="exit"
// // //                   transition={{ duration: 0.35, ease: "easeInOut" }}
// // //                 >
// // //                   <div className="mb-3 flex items-center gap-3">
// // //                     <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#DA2128] text-lg font-bold text-white shadow-lg shadow-[#DA2128]/40">
// // //                       {String(active + 1).padStart(2, "0")}
// // //                     </span>
// // //                     <div>
// // //                       <p className="text-3xl font-extrabold text-[#DA2128] sm:text-4xl">
// // //                         {milestones[active].year}
// // //                       </p>
// // //                     </div>
// // //                   </div>
// // //                   <h3 className="mb-3 text-xl font-bold text-white sm:text-2xl">
// // //                     {milestones[active].title}
// // //                   </h3>
// // //                   <p className="text-sm leading-relaxed text-white/70 sm:text-base">
// // //                     {milestones[active].desc}
// // //                   </p>
// // //                 </motion.div>
// // //               </AnimatePresence>
// // //             </div>

// // //             <button
// // //               onClick={next}
// // //               disabled={active === milestones.length - 1}
// // //               className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white transition-all hover:bg-[#DA2128] disabled:opacity-30 disabled:hover:bg-white/5"
// // //               aria-label="Next milestone"
// // //             >
// // //               <ChevronRight size={20} />
// // //             </button>
// // //           </div>

// // //           {/* Progress bar */}
// // //           <div className="mt-8 h-1 overflow-hidden rounded-full bg-white/10">
// // //             <motion.div
// // //               className="h-full rounded-full bg-[#DA2128]"
// // //               animate={{
// // //                 width: `${((active + 1) / milestones.length) * 100}%`,
// // //               }}
// // //               transition={{ duration: 0.4 }}
// // //             />
// // //           </div>
// // //           <p className="mt-2 text-center text-xs text-white/40">
// // //             {active + 1} of {milestones.length} milestones
// // //           </p>
// // //         </div>

// // //         {/* Desktop horizontal timeline preview */}
// // //         <div className="mt-16 hidden lg:block">
// // //           <div className="relative">
// // //             <div className="absolute left-0 right-0 top-4 h-0.5 bg-white/10" />
// // //             <div className="grid grid-cols-5 gap-4">
// // //               {[0, 3, 7, 11, 14].map((idx) => (
// // //                 <button
// // //                   key={idx}
// // //                   onClick={() => goTo(idx)}
// // //                   className="group relative flex flex-col items-center pt-0 text-center"
// // //                 >
// // //                   <div
// // //                     className={`relative z-10 mb-3 h-8 w-8 rounded-full border-2 transition-all ${
// // //                       active === idx
// // //                         ? "border-[#DA2128] bg-[#DA2128] scale-125"
// // //                         : "border-white/30 bg-[#1a1a1a] group-hover:border-[#DA2128]"
// // //                     }`}
// // //                   >
// // //                     <div
// // //                       className={`absolute inset-1.5 rounded-full ${
// // //                         active === idx ? "bg-white" : "bg-transparent"
// // //                       }`}
// // //                     />
// // //                   </div>
// // //                   <span
// // //                     className={`text-sm font-bold transition-colors ${
// // //                       active === idx
// // //                         ? "text-[#DA2128]"
// // //                         : "text-white/50 group-hover:text-white/80"
// // //                     }`}
// // //                   >
// // //                     {milestones[idx].year}
// // //                   </span>
// // //                   <span className="mt-1 text-xs text-white/40">
// // //                     {milestones[idx].title}
// // //                   </span>
// // //                 </button>
// // //               ))}
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </section>
// // //   );
// // // }





// // // new new code 




// // import { motion } from "framer-motion";
// // import { FaCalendarAlt } from "react-icons/fa";

// // const milestones = [
// //   {
// //     year: "1920",
// //     title: "Maiden Conference",
// //     desc: "ASSOCHAM's maiden conference held at Royal Exchange, Calcutta.",
// //     tag: "Founding",
// //   },
// //   {
// //     year: "1921",
// //     title: "First Annual Report",
// //     desc: "First annual report signed at Royal Exchange, Calcutta. Name changed from the Association of Chambers of Commerce of India and Ceylon to the Associated Chambers of Commerce of India and Ceylon.",
// //     tag: "Milestone",
// //   },
// //   {
// //     year: "1922",
// //     title: "PHD Chamber Joins",
// //     desc: "PHD Chamber of Commerce and Industry joins ASSOCHAM.",
// //     tag: "Growth",
// //   },
// //   {
// //     year: "1934",
// //     title: "Central Fund Created",
// //     desc: "Central fund created for a European Commercial Representative for ASSOCHAM.",
// //     tag: "Expansion",
// //   },
// //   {
// //     year: "1942",
// //     title: "Commitment to Progress",
// //     desc: "ASSOCHAM states the desire of the British Community in India to continue to assist in the progress of agriculture and the industry.",
// //     tag: "Nation",
// //   },
// //   {
// //     year: "1949",
// //     title: "Managing Agency Debate",
// //     desc: "ASSOCHAM debates on Managing Agency System.",
// //     tag: "Policy",
// //   },
// //   {
// //     year: "1964",
// //     title: "A New Identity",
// //     desc: "Name changed to Associated Chambers of Commerce and Industry of India.",
// //     tag: "Milestone",
// //   },
// //   {
// //     year: "1965",
// //     title: "Service to the Nation",
// //     desc: "ASSOCHAM ploughs four acres of land of each family holding free of charge in Punjab's Khem Karan town, devastated by the Indo-Pak war.",
// //     tag: "Nation First",
// //   },
// //   {
// //     year: "1968",
// //     title: "Indian Leadership",
// //     desc: "First non-British president — N M Wagle assumes charge.",
// //     tag: "Leadership",
// //   },
// //   {
// //     year: "1972",
// //     title: "Base Shifts to Delhi",
// //     desc: "ASSOCHAM shifts base from Calcutta to the national capital, Delhi.",
// //     tag: "Milestone",
// //   },
// //   {
// //     year: "1987",
// //     title: "IMC Bombay Joins",
// //     desc: "Indian Merchants' Chamber, Bombay joins ASSOCHAM, strengthening national outreach.",
// //     tag: "Growth",
// //   },
// //   {
// //     year: "1998",
// //     title: "JRD Memorial Lectures",
// //     desc: "JRD Memorial Lectures launched, honouring the legacy of Bharat Ratna J.R.D. Tata.",
// //     tag: "Legacy",
// //   },
// //   {
// //     year: "2006",
// //     title: "First Overseas Office",
// //     desc: "First overseas office set up in China, marking global expansion.",
// //     tag: "Global",
// //   },
// //   {
// //     year: "2013",
// //     title: "Chanakyapuri HQ",
// //     desc: "ASSOCHAM moves to its new office at Chanakyapuri in New Delhi.",
// //     tag: "Milestone",
// //   },
// //   {
// //     year: "2020",
// //     title: "Centenary Celebrations",
// //     desc: "Celebrated 100 years of an illustrious journey — a century of shaping India's economic destiny.",
// //     tag: "Centenary",
// //   },
// // ];

// // export default function Milestones() {
// //   return (
// //     <section id="milestones" className="relative overflow-hidden bg-white py-20 md:py-4">
// //       {/* Decorative elements */}
// //       <div className="pointer-events-none absolute left-1/4 top-0 h-px w-1/2 bg-gradient-to-r from-transparent via-[#DA2128]/40 to-transparent" />
// //       <div className="pointer-events-none absolute -left-32 top-40 h-96 w-96 rounded-full bg-[#DA2128]/5 blur-3xl" />
// //       <div className="pointer-events-none absolute -right-32 bottom-40 h-96 w-96 rounded-full bg-[#DA2128]/5 blur-3xl" />
// //       <div className="pointer-events-none absolute right-0 top-20 h-48 w-48 rounded-full bg-[#DA2128]/[0.03] blob animate-float-delayed" />

// //       <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
// //         {/* Section Header */}
// //         <div className="mb-16 text-center">
// //           <motion.span
// //             initial={{ opacity: 0 }}
// //             whileInView={{ opacity: 1 }}
// //             viewport={{ once: true }}
// //             className="mb-3 inline-flex items-center gap-2 rounded-full bg-[#DA2128]/10 px-4 py-1.5 text-xs font-bold tracking-[0.2em] text-[#DA2128] uppercase"
// //           >
// //             {/* <FaCalendarAlt /> Infographic Timeline */}
// //           </motion.span>
// //           <motion.h2
// //             initial={{ opacity: 0, y: 20 }}
// //             whileInView={{ opacity: 1, y: 0 }}
// //             viewport={{ once: true }}
// //             className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl md:text-5xl"
// //           >
// //             ASSOCHAM <span className="gradient-text">Milestones</span>
// //           </motion.h2>
// //           <div className="mx-auto mt-4 accent-bar" />
// //           <p className="mx-auto mt-5 max-w-xl text-sm text-gray-600 sm:text-base">
// //             From Royal Exchange, Calcutta (1920) to Chanakyapuri, New Delhi —
// //             over a century of leadership, advocacy and nation building.
// //           </p>
// //         </div>

// //         {/* Desktop Timeline (md+) */}
// //         <div className="relative hidden md:block">
// //           {/* Central line */}
// //           <div className="absolute left-1/2 top-0 h-full w-0.5 -translate-x-1/2 bg-gradient-to-b from-transparent via-[#DA2128]/30 via-[#DA2128]/50 to-transparent" />
// //           <div className="absolute left-1/2 top-0 h-full w-0.5 -translate-x-1/2 bg-gradient-to-b from-transparent via-gray-200 to-transparent" />

// //           <div className="space-y-12">
// //             {milestones.map((m, i) => {
// //               const isLeft = i % 2 === 0;
// //               return (
// //                 <motion.div
// //                   key={m.year}
// //                   initial={{ opacity: 0, x: isLeft ? -40 : 40 }}
// //                   whileInView={{ opacity: 1, x: 0 }}
// //                   viewport={{ once: true, margin: "-80px" }}
// //                   transition={{ duration: 0.6, delay: 0.1 }}
// //                   className={`relative flex items-center ${
// //                     isLeft ? "flex-row" : "flex-row-reverse"
// //                   }`}
// //                 >
// //                   {/* Content card */}
// //                   <div className={`w-1/2 ${isLeft ? "pr-12 text-right" : "pl-12 text-left"}`}>
// //                     <motion.div
// //                       whileHover={{ scale: 1.02, y: -4 }}
// //                       className={`card-glow group relative inline-block max-w-md rounded-2xl border border-gray-100 bg-[#FAF7F2] p-6 transition-all hover:border-[#DA2128]/40 ${
// //                         isLeft ? "ml-auto text-left" : "mr-auto text-left"
// //                       }`}
// //                     >
// //                       <div className="mb-3 flex items-center justify-between gap-3">
// //                         <span className="rounded-full bg-[#DA2128]/10 px-3 py-1 text-[10px] font-bold tracking-wider text-[#DA2128] uppercase">
// //                           {m.tag}
// //                         </span>
// //                         <span className="text-2xl font-black text-[#DA2128] md:text-3xl">
// //                           {m.year}
// //                         </span>
// //                       </div>
// //                       <h3 className="mb-2 text-lg font-bold text-gray-900 md:text-xl">
// //                         {m.title}
// //                       </h3>
// //                       <p className="text-sm leading-relaxed text-gray-600">
// //                         {m.desc}
// //                       </p>
// //                       {/* Accent corner */}
// //                       <div className={`absolute top-0 h-1 w-12 rounded-b bg-[#DA2128] transition-all group-hover:w-20 ${isLeft ? "left-6" : "right-6"}`} />
// //                     </motion.div>
// //                   </div>

// //                   {/* Center dot */}
// //                   <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
// //                     <div className="relative">
// //                       <div className="absolute inset-0 animate-pulse-ring rounded-full bg-[#DA2128]/20" />
// //                       <div className="relative flex h-12 w-12 items-center justify-center rounded-full border-2 border-[#DA2128] bg-white shadow-lg shadow-[#DA2128]/20">
// //                         <span className="text-[10px] font-bold text-[#DA2128]">
// //                           {String(i + 1).padStart(2, "0")}
// //                         </span>
// //                       </div>
// //                     </div>
// //                   </div>

// //                   <div className="w-1/2" />
// //                 </motion.div>
// //               );
// //             })}
// //           </div>

// //           {/* Start & end caps */}
// //           <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-2">
// //             <div className="h-4 w-4 rounded-full bg-[#DA2128] shadow-lg shadow-[#DA2128]/60" />
// //           </div>
// //           <div className="absolute left-1/2 bottom-0 -translate-x-1/2 translate-y-2">
// //             <div className="h-4 w-4 rounded-full bg-[#DA2128] shadow-lg shadow-[#DA2128]/60" />
// //           </div>
// //         </div>

// //         {/* Mobile Timeline (sm only) */}
// //         <div className="relative md:hidden">
// //           <div className="absolute left-5 top-0 h-full w-0.5 bg-gradient-to-b from-[#DA2128]/60 via-[#DA2128]/30 to-transparent" />

// //           <div className="space-y-8 pl-14">
// //             {milestones.map((m, i) => (
// //               <motion.div
// //                 key={m.year}
// //                 initial={{ opacity: 0, x: -20 }}
// //                 whileInView={{ opacity: 1, x: 0 }}
// //                 viewport={{ once: true, margin: "-50px" }}
// //                 transition={{ duration: 0.5, delay: i * 0.03 }}
// //                 className="relative"
// //               >
// //                 {/* Dot */}
// //                 <div className="absolute -left-[2.60rem] top-5">
// //                   <div className="flex h-6 w-6 items-center justify-center rounded-full border-2 border-[#DA2128] bg-white shadow-md shadow-[#DA2128]/20">
// //                     <div className="h-2 w-2 rounded-full bg-[#DA2128]" />
// //                   </div>
// //                 </div>

// //                 <div className="card-glow rounded-2xl border border-gray-100 bg-[#FAF7F2] p-5">
// //                   <div className="mb-2 flex items-center justify-between">
// //                     <span className="rounded-full bg-[#DA2128]/10 px-2.5 py-0.5 text-[9px] font-bold tracking-wider text-[#DA2128] uppercase">
// //                       {m.tag}
// //                     </span>
// //                     <span className="text-2xl font-black text-[#DA2128]">
// //                       {m.year}
// //                     </span>
// //                   </div>
// //                   <h3 className="mb-1.5 text-base font-bold text-gray-900">
// //                     {m.title}
// //                   </h3>
// //                   <p className="text-xs leading-relaxed text-gray-600">
// //                     {m.desc}
// //                   </p>
// //                 </div>
// //               </motion.div>
// //             ))}
// //           </div>
// //         </div>

// //         {/* Footer stat */}
// //         <motion.div
// //           initial={{ opacity: 0, y: 30 }}
// //           whileInView={{ opacity: 1, y: 0 }}
// //           viewport={{ once: true }}
// //           className="mt-20 text-center"
// //         >
// //           <div className="inline-flex flex-col items-center gap-3 rounded-2xl border border-[#DA2128]/20 bg-[#FAF7F2] px-8 py-6 shadow-lg shadow-black/5 sm:flex-row sm:gap-6">
// //             <div className="text-center">
// //               <p className="text-3xl font-black text-[#DA2128] md:text-4xl">100+</p>
// //               <p className="text-xs font-medium text-gray-500">Years of Legacy</p>
// //             </div>
// //             <div className="hidden h-10 w-px bg-gray-200 sm:block" />
// //             <div className="text-center">
// //               <p className="text-3xl font-black text-gray-900 md:text-4xl">15</p>
// //               <p className="text-xs font-medium text-gray-500">Key Milestones</p>
// //             </div>
// //             <div className="hidden h-10 w-px bg-gray-200 sm:block" />
// //             <div className="text-center">
// //               <p className="text-3xl font-black text-[#DA2128] md:text-4xl">1</p>
// //               <p className="text-xs font-medium text-gray-500">
// //                 Unbroken Journey
// //               </p>
// //             </div>
// //           </div>
// //         </motion.div>
// //       </div>
// //     </section>
// //   );
// // }







// // new code 





// import { useRef, useState, useEffect, useLayoutEffect } from "react";
// import { motion, useScroll, useTransform } from "framer-motion";
// import {
//   FaCalendarAlt,
//   FaArrowRight,
//   FaChevronDown,
//   FaFlag,
//   FaLandmark,
//   FaChartLine,
//   FaGlobeAsia,
//   FaHandsHelping,
//   FaBalanceScale,
//   FaHandHoldingHeart,
//   FaUserTie,
//   FaGlobe,
//   FaAward,
//   FaTrophy,
// } from "react-icons/fa";

// const milestones = [
//   {
//     year: "1920",
//     title: "Maiden Conference",
//     desc: "ASSOCHAM's maiden conference held at Royal Exchange, Calcutta.",
//     tag: "Founding",
//   },
//   {
//     year: "1921",
//     title: "First Annual Report",
//     desc: "First annual report signed at Royal Exchange, Calcutta. Name changed from the Association of Chambers of Commerce of India and Ceylon to the Associated Chambers of Commerce of India and Ceylon.",
//     tag: "Milestone",
//   },
//   {
//     year: "1922",
//     title: "PHD Chamber Joins",
//     desc: "PHD Chamber of Commerce and Industry joins ASSOCHAM.",
//     tag: "Growth",
//   },
//   {
//     year: "1934",
//     title: "Central Fund Created",
//     desc: "Central fund created for a European Commercial Representative for ASSOCHAM.",
//     tag: "Expansion",
//   },
//   {
//     year: "1942",
//     title: "Commitment to Progress",
//     desc: "ASSOCHAM states the desire of the British Community in India to continue to assist in the progress of agriculture and the industry.",
//     tag: "Nation",
//   },
//   {
//     year: "1949",
//     title: "Managing Agency Debate",
//     desc: "ASSOCHAM debates on Managing Agency System.",
//     tag: "Policy",
//   },
//   {
//     year: "1964",
//     title: "A New Identity",
//     desc: "Name changed to Associated Chambers of Commerce and Industry of India.",
//     tag: "Milestone",
//   },
//   {
//     year: "1965",
//     title: "Service to the Nation",
//     desc: "ASSOCHAM ploughs four acres of land of each family holding free of charge in Punjab's Khem Karan town, devastated by the Indo-Pak war.",
//     tag: "Nation First",
//   },
//   {
//     year: "1968",
//     title: "Indian Leadership",
//     desc: "First non-British president — N M Wagle assumes charge.",
//     tag: "Leadership",
//   },
//   {
//     year: "1972",
//     title: "Base Shifts to Delhi",
//     desc: "ASSOCHAM shifts base from Calcutta to the national capital, Delhi.",
//     tag: "Milestone",
//   },
//   {
//     year: "1987",
//     title: "IMC Bombay Joins",
//     desc: "Indian Merchants' Chamber, Bombay joins ASSOCHAM, strengthening national outreach.",
//     tag: "Growth",
//   },
//   {
//     year: "1998",
//     title: "JRD Memorial Lectures",
//     desc: "JRD Memorial Lectures launched, honouring the legacy of Bharat Ratna J.R.D. Tata.",
//     tag: "Legacy",
//   },
//   {
//     year: "2006",
//     title: "First Overseas Office",
//     desc: "First overseas office set up in China, marking global expansion.",
//     tag: "Global",
//   },
//   {
//     year: "2013",
//     title: "Chanakyapuri HQ",
//     desc: "ASSOCHAM moves to its new office at Chanakyapuri in New Delhi.",
//     tag: "Milestone",
//   },
//   {
//     year: "2020",
//     title: "Centenary Celebrations",
//     desc: "Celebrated 100 years of an illustrious journey — a century of shaping India's economic destiny.",
//     tag: "Centenary",
//   },
// ];

// const iconMap = {
//   Founding: FaFlag,
//   Milestone: FaLandmark,
//   Growth: FaChartLine,
//   Expansion: FaGlobeAsia,
//   Nation: FaHandsHelping,
//   Policy: FaBalanceScale,
//   "Nation First": FaHandHoldingHeart,
//   Leadership: FaUserTie,
//   Global: FaGlobe,
//   Legacy: FaAward,
//   Centenary: FaTrophy,
// };

// const tones = ["#DA2128", "#C21F26", "#AA1B22", "#92171D", "#7A1319"];

// /* ---------------- shared card ---------------- */
// function MilestoneCard({ m, Icon, position, animated }) {
//   const isTop = position === "top";
//   const motionProps = animated
//     ? {
//         initial: { opacity: 0, y: isTop ? 14 : -14 },
//         whileInView: { opacity: 1, y: 0 },
//         viewport: { once: true, amount: 0.5 },
//         transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] },
//       }
//     : {};

//   const Wrapper = animated ? motion.div : "div";

//   return (
//     <Wrapper
//       {...motionProps}
//       className={`group relative w-[210px] flex-shrink-0 rounded-2xl border border-gray-100 bg-white shadow-lg shadow-black/5 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl sm:w-[250px] ${
//         isTop
//           ? "px-4 pt-4 pb-8 sm:px-5 sm:pt-5 sm:pb-9"
//           : "px-4 pt-8 pb-4 sm:px-5 sm:pt-9 sm:pb-5"
//       }`}
//     >
//       <div
//         className={`absolute left-1/2 flex h-10 w-10 -translate-x-1/2 items-center justify-center rounded-xl bg-[#DA2128] text-white shadow-md shadow-[#DA2128]/30 sm:h-11 sm:w-11 ${
//           isTop ? "-bottom-5" : "-top-5"
//         }`}
//       >
//         <Icon className="text-sm sm:text-base" />
//       </div>

//       <span className="mb-2 inline-block rounded-full bg-[#DA2128]/10 px-2.5 py-0.5 text-[9px] font-bold tracking-wider text-[#DA2128] uppercase sm:text-[10px]">
//         {m.tag}
//       </span>
//       <h3 className="text-sm font-bold leading-snug text-gray-900 sm:text-base">
//         {m.title}
//       </h3>
//       <p
//         className="mt-1.5 text-[11px] leading-relaxed text-gray-500 sm:text-xs"
//         style={{
//           display: "-webkit-box",
//           WebkitLineClamp: 3,
//           WebkitBoxOrient: "vertical",
//           overflow: "hidden",
//         }}
//       >
//         {m.desc}
//       </p>
//     </Wrapper>
//   );
// }

// function TimelineItem({ m, i, animated }) {
//   const Icon = iconMap[m.tag] || FaLandmark;
//   const isTop = i % 2 === 0;
//   const tone = tones[i % tones.length];

//   return (
//     <div className="relative flex w-[230px] flex-shrink-0 flex-col items-center sm:w-[270px]">
//       <div className="flex h-[185px] w-full items-end justify-center">
//         {isTop && (
//           <MilestoneCard m={m} Icon={Icon} position="top" animated={animated} />
//         )}
//       </div>

//       <div className="relative flex h-5 w-full items-center justify-center">
//         {isTop && (
//           <>
//             <span className="absolute bottom-0 h-5 border-l-2 border-dashed border-[#DA2128]/40" />
//             <span className="absolute -bottom-1 h-3 w-3 rounded-full border-2 border-white bg-[#DA2128] shadow" />
//           </>
//         )}
//       </div>

//       <div
//         className="relative flex h-9 w-full items-center justify-center text-xs font-black italic tracking-wide text-white sm:h-10 sm:text-sm"
//         style={{
//           background: tone,
//           clipPath:
//             i === 0
//               ? "polygon(0 0, calc(100% - 16px) 0, 100% 50%, calc(100% - 16px) 100%, 0 100%)"
//               : "polygon(0 0, calc(100% - 16px) 0, 100% 50%, calc(100% - 16px) 100%, 0 100%, 16px 50%)",
//           marginLeft: i === 0 ? 0 : -16,
//         }}
//       >
//         {m.year}
//       </div>

//       <div className="relative flex h-5 w-full items-center justify-center">
//         {!isTop && (
//           <>
//             <span className="absolute top-0 h-5 border-l-2 border-dashed border-[#DA2128]/40" />
//             <span className="absolute -top-1 h-3 w-3 rounded-full border-2 border-white bg-[#DA2128] shadow" />
//           </>
//         )}
//       </div>

//       <div className="flex h-[185px] w-full items-start justify-center">
//         {!isTop && (
//           <MilestoneCard m={m} Icon={Icon} position="bottom" animated={animated} />
//         )}
//       </div>
//     </div>
//   );
// }

// /* ---------------- desktop: pinned scroll-jack ---------------- */
// function PinnedRibbon() {
//   const wrapperRef = useRef(null);
//   const trackRef = useRef(null);
//   const [distance, setDistance] = useState(0);

//   useLayoutEffect(() => {
//     const measure = () => {
//       if (!trackRef.current) return;
//       const trackWidth = trackRef.current.scrollWidth;
//       const viewportWidth = window.innerWidth;
//       setDistance(Math.max(trackWidth - viewportWidth, 0));
//     };

//     measure();

//     const ro = new ResizeObserver(measure);
//     if (trackRef.current) ro.observe(trackRef.current);
//     window.addEventListener("resize", measure);

//     return () => {
//       ro.disconnect();
//       window.removeEventListener("resize", measure);
//     };
//   }, []);

//   const { scrollYProgress } = useScroll({
//     target: wrapperRef,
//     offset: ["start start", "end end"],
//   });

//   // Direct 1:1 mapping — no spring lag, track moves exactly with scroll
//   const x = useTransform(scrollYProgress, [0, 1], [0, -distance]);
//   const progressWidth = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);
//   const hintOpacity = useTransform(scrollYProgress, [0, 0.08], [1, 0]);
//   const counter = useTransform(scrollYProgress, (v) =>
//     String(Math.min(milestones.length, Math.round(v * (milestones.length - 1)) + 1)).padStart(2, "0")
//   );

//   return (
//     <div
//       ref={wrapperRef}
//       className="relative"
//       style={{ height: `calc(100vh + ${distance}px)` }}
//     >
//       <div className="sticky top-0 h-screen w-full overflow-hidden bg-[#FAF7F2]">
//         <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white via-[#FAF7F2] to-white" />

//         {/* Edge fades */}
//         <div className="pointer-events-none absolute inset-y-0 left-0 z-20 w-16 bg-gradient-to-r from-[#FAF7F2] to-transparent" />
//         <div className="pointer-events-none absolute inset-y-0 right-0 z-20 w-16 bg-gradient-to-l from-[#FAF7F2] to-transparent" />

//         {/* Top HUD */}
//         <div className="pointer-events-none absolute left-0 right-0 top-0 z-30 px-4 pt-6 sm:px-10 md:pt-10">
//           <div className="mx-auto flex max-w-7xl flex-col gap-3">
//             <div className="flex items-center justify-between">
//               <p className="text-[10px] font-bold tracking-[0.25em] text-gray-500 uppercase sm:text-xs">
//                 ASSOCHAM Milestone{" "}
//                 {/* <motion.span className="text-[#DA2128]">{counter}</motion.span>
//                 <span className="text-gray-300"> / {milestones.length}</span> */}
//               </p>
//               <motion.span
//                 style={{ opacity: hintOpacity }}
//                 className="hidden items-center gap-2 text-[10px] font-bold tracking-widest text-gray-400 uppercase sm:flex"
//               >
//                 Keep scrolling
//                 <FaChevronDown className="text-[#DA2128]" />
//               </motion.span>
//             </div>
//             <div className="h-1 w-full overflow-hidden rounded-full bg-gray-200">
//               <motion.div
//                 style={{ width: progressWidth }}
//                 className="h-full rounded-full bg-gradient-to-r from-[#DA2128] to-[#F0484E]"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Horizontal track */}
//         <div className="relative flex h-full w-full items-center">
//           <motion.div
//             ref={trackRef}
//             style={{ x, willChange: "transform" }}
//             className="flex items-center gap-0 px-6 sm:px-10"
//           >
//             {milestones.map((m, i) => (
//               <TimelineItem key={m.year} m={m} i={i} animated={false} />
//             ))}
//           </motion.div>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ---------------- mobile: native swipe (no scroll-jack) ---------------- */
// function SwipeRibbon() {
//   return (
//     <div className="relative mx-auto max-w-7xl">
//       <div className="pointer-events-none absolute inset-y-0 left-0 z-20 w-8 bg-gradient-to-r from-white to-transparent" />
//       <div className="pointer-events-none absolute inset-y-0 right-0 z-20 w-8 bg-gradient-to-l from-white to-transparent" />
//       <div
//         className="scrollbar-hide flex snap-x snap-mandatory overflow-x-auto scroll-smooth px-4 py-6"
//         style={{ WebkitOverflowScrolling: "touch" }}
//       >
//         {milestones.map((m, i) => (
//           <div key={m.year} className="snap-center">
//             <TimelineItem m={m} i={i} animated />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// /* ---------------- main export ---------------- */
// export default function Milestones() {
//   const [isDesktop, setIsDesktop] = useState(
//     typeof window !== "undefined" ? window.innerWidth >= 768 : true
//   );

//   useEffect(() => {
//     const mq = window.matchMedia("(min-width: 768px)");
//     const handler = (e) => setIsDesktop(e.matches);
//     mq.addEventListener("change", handler);
//     return () => mq.removeEventListener("change", handler);
//   }, []);

//   return (
//     <section id="milestones" className="relative bg-white">
//       {/* Intro header */}
//       <div className="relative mx-auto max-w-7xl px-4 pt-20 sm:px-6 lg:px-8 md:pt-24">
//         <div className="text-center">
//           <motion.span
//             initial={{ opacity: 0 }}
//             whileInView={{ opacity: 1 }}
//             viewport={{ once: true }}
//             className="mb-3 inline-flex items-center gap-2 rounded-full bg-[#DA2128]/10 px-4 py-1.5 text-xs font-bold tracking-[0.2em] text-[#DA2128] uppercase"
//           >
            
//           </motion.span>
//           <motion.h2
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl md:text-5xl"
//           >
//             ASSOCHAM <span className="gradient-text">Milestones</span>
//           </motion.h2>
//           <div className="mx-auto mt-4 accent-bar" />
//           <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-gray-600 sm:text-base">
//             {isDesktop
//               ? "Scroll through the next section — it glides horizontally through 100+ years of legacy, from Royal Exchange Calcutta (1920) to Chanakyapuri, New Delhi."
//               : "Swipe sideways through 100+ years of legacy, from Royal Exchange Calcutta (1920) to Chanakyapuri, New Delhi."}
//           </p>

//           <motion.div
//             initial={{ opacity: 0 }}
//             whileInView={{ opacity: 1 }}
//             viewport={{ once: true }}
//             transition={{ delay: 0.3 }}
//             className="mt-6 inline-flex items-center gap-2 text-[11px] font-semibold tracking-widest text-gray-400 uppercase"
//           >
//             {isDesktop ? "Keep scrolling to begin" : "Swipe to explore"}
//             {isDesktop ? (
//               <motion.span
//                 animate={{ y: [0, 6, 0] }}
//                 transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
//               >
//                 <FaChevronDown className="text-[#DA2128]" />
//               </motion.span>
//             ) : (
//               <motion.span
//                 animate={{ x: [0, 6, 0] }}
//                 transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
//               >
//                 <FaArrowRight className="text-[#DA2128]" />
//               </motion.span>
//             )}
//           </motion.div>
//         </div>
//       </div>

//       <div className="mt-10 sm:mt-14">
//         {isDesktop ? <PinnedRibbon /> : <SwipeRibbon />}
//       </div>

//       {/* Stats footer */}
//       <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.6 }}
//           className="mx-auto max-w-4xl text-center"
//         >
//           {/* <div className="inline-flex flex-col items-center gap-3 rounded-2xl border border-[#DA2128]/20 bg-[#FAF7F2] px-8 py-6 shadow-lg shadow-black/5 sm:flex-row sm:gap-6">
//             <div className="text-center">
//               <p className="text-3xl font-black text-[#DA2128] md:text-4xl">
//                 100+
//               </p>
//               <p className="text-xs font-medium text-gray-500">
//                 Years of Legacy
//               </p>
//             </div>
//             <div className="hidden h-10 w-px bg-gray-200 sm:block" />
//             <div className="text-center">
//               <p className="text-3xl font-black text-gray-900 md:text-4xl">15</p>
//               <p className="text-xs font-medium text-gray-500">Key Milestones</p>
//             </div>
//             <div className="hidden h-10 w-px bg-gray-200 sm:block" />
//             <div className="text-center">
//               <p className="text-3xl font-black text-[#DA2128] md:text-4xl">1</p>
//               <p className="text-xs font-medium text-gray-500">
//                 Unbroken Journey
//               </p>
//             </div>
//           </div> */}
//         </motion.div>
//       </div>
//     </section>
//   );
// }




// new new code 



import { useRef, useState, useEffect, useLayoutEffect } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import {
  FaCalendarAlt,
  FaArrowRight,
  FaChevronDown,
  FaFlag,
  FaLandmark,
  FaChartLine,
  FaGlobeAsia,
  FaHandsHelping,
  FaBalanceScale,
  FaHandHoldingHeart,
  FaUserTie,
  FaGlobe,
  FaAward,
  FaTrophy,
} from "react-icons/fa";

/* =========================================================
   TOGGLE: Screen-Lock (Pinned Scroll-Jack) Animation
   1 = ON  -> Desktop uses the pinned/scroll-locked timeline
              (PinnedRibbon) — same lock-scroll as before, untouched.
   0 = OFF -> Desktop uses a "stop → move → stop → move"
              auto-scrolling ribbon instead (AutoScrollRibbon).
========================================================= */
const SCREEN_LOCK_ANIMATION = 0; // <-- change to 0 to disable lock-scroll

const milestones = [
  {
    year: "1920",
    title: "Maiden Conference",
    desc: "ASSOCHAM's maiden conference held at Royal Exchange, Calcutta.",
    tag: "Founding",
  },
  {
    year: "1921",
    title: "First Annual Report",
    desc: "First annual report signed at Royal Exchange, Calcutta. Name changed from the Association of Chambers of Commerce of India and Ceylon to the Associated Chambers of Commerce of India and Ceylon.",
    tag: "Milestone",
  },
  {
    year: "1922",
    title: "PHD Chamber Joins",
    desc: "PHD Chamber of Commerce and Industry joins ASSOCHAM.",
    tag: "Growth",
  },
  {
    year: "1934",
    title: "Central Fund Created",
    desc: "Central fund created for a European Commercial Representative for ASSOCHAM.",
    tag: "Expansion",
  },
  {
    year: "1942",
    title: "Commitment to Progress",
    desc: "ASSOCHAM states the desire of the British Community in India to continue to assist in the progress of agriculture and the industry.",
    tag: "Nation",
  },
  {
    year: "1949",
    title: "Managing Agency Debate",
    desc: "ASSOCHAM debates on Managing Agency System.",
    tag: "Policy",
  },
  {
    year: "1964",
    title: "A New Identity",
    desc: "Name changed to Associated Chambers of Commerce and Industry of India.",
    tag: "Milestone",
  },
  {
    year: "1965",
    title: "Service to the Nation",
    desc: "ASSOCHAM ploughs four acres of land of each family holding free of charge in Punjab's Khem Karan town, devastated by the Indo-Pak war.",
    tag: "Nation First",
  },
  {
    year: "1968",
    title: "Indian Leadership",
    desc: "First non-British president — N M Wagle assumes charge.",
    tag: "Leadership",
  },
  {
    year: "1972",
    title: "Base Shifts to Delhi",
    desc: "ASSOCHAM shifts base from Calcutta to the national capital, Delhi.",
    tag: "Milestone",
  },
  {
    year: "1987",
    title: "IMC Bombay Joins",
    desc: "Indian Merchants' Chamber, Bombay joins ASSOCHAM, strengthening national outreach.",
    tag: "Growth",
  },
  {
    year: "1998",
    title: "JRD Memorial Lectures",
    desc: "JRD Memorial Lectures launched, honouring the legacy of Bharat Ratna J.R.D. Tata.",
    tag: "Legacy",
  },
  {
    year: "2006",
    title: "First Overseas Office",
    desc: "First overseas office set up in China, marking global expansion.",
    tag: "Global",
  },
  {
    year: "2013",
    title: "Chanakyapuri HQ",
    desc: "ASSOCHAM moves to its new office at Chanakyapuri in New Delhi.",
    tag: "Milestone",
  },
  {
    year: "2020",
    title: "Centenary Celebrations",
    desc: "Celebrated 100 years of an illustrious journey — a century of shaping India's economic destiny.",
    tag: "Centenary",
  },
];

const iconMap = {
  Founding: FaFlag,
  Milestone: FaLandmark,
  Growth: FaChartLine,
  Expansion: FaGlobeAsia,
  Nation: FaHandsHelping,
  Policy: FaBalanceScale,
  "Nation First": FaHandHoldingHeart,
  Leadership: FaUserTie,
  Global: FaGlobe,
  Legacy: FaAward,
  Centenary: FaTrophy,
};

const tones = ["#DA2128", "#C21F26", "#AA1B22", "#92171D", "#7A1319"];

/* ---------------- shared card ---------------- */
function MilestoneCard({ m, Icon, position, animated }) {
  const isTop = position === "top";
  const motionProps = animated
    ? {
        initial: { opacity: 0, y: isTop ? 14 : -14 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true, amount: 0.5 },
        transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] },
      }
    : {};

  const Wrapper = animated ? motion.div : "div";

  return (
    <Wrapper
      {...motionProps}
      className={`group relative w-[210px] flex-shrink-0 rounded-2xl border border-gray-100 bg-white shadow-lg shadow-black/5 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl sm:w-[250px] ${
        isTop
          ? "px-4 pt-4 pb-8 sm:px-5 sm:pt-5 sm:pb-9"
          : "px-4 pt-8 pb-4 sm:px-5 sm:pt-9 sm:pb-5"
      }`}
    >
      <div
        className={`absolute left-1/2 flex h-10 w-10 -translate-x-1/2 items-center justify-center rounded-xl bg-[#DA2128] text-white shadow-md shadow-[#DA2128]/30 sm:h-11 sm:w-11 ${
          isTop ? "-bottom-5" : "-top-5"
        }`}
      >
        <Icon className="text-sm sm:text-base" />
      </div>

      <span className="mb-2 inline-block rounded-full bg-[#DA2128]/10 px-2.5 py-0.5 text-[9px] font-bold tracking-wider text-[#DA2128] uppercase sm:text-[10px]">
        {m.tag}
      </span>
      <h3 className="text-sm font-bold leading-snug text-gray-900 sm:text-base">
        {m.title}
      </h3>
      <p
        className="mt-1.5 text-[11px] leading-relaxed text-gray-500 sm:text-xs"
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {m.desc}
      </p>
    </Wrapper>
  );
}

function TimelineItem({ m, i, animated }) {
  const Icon = iconMap[m.tag] || FaLandmark;
  const isTop = i % 2 === 0;
  const tone = tones[i % tones.length];

  return (
    <div className="relative flex w-[230px] flex-shrink-0 flex-col items-center sm:w-[270px]">
      <div className="flex h-[185px] w-full items-end justify-center">
        {isTop && (
          <MilestoneCard m={m} Icon={Icon} position="top" animated={animated} />
        )}
      </div>

      <div className="relative flex h-5 w-full items-center justify-center">
        {isTop && (
          <>
            <span className="absolute bottom-0 h-5 border-l-2 border-dashed border-[#DA2128]/40" />
            <span className="absolute -bottom-1 h-3 w-3 rounded-full border-2 border-white bg-[#DA2128] shadow" />
          </>
        )}
      </div>

      <div
        className="relative flex h-9 w-full items-center justify-center text-xs font-black italic tracking-wide text-white sm:h-10 sm:text-sm"
        style={{
          background: tone,
          clipPath:
            i === 0
              ? "polygon(0 0, calc(100% - 16px) 0, 100% 50%, calc(100% - 16px) 100%, 0 100%)"
              : "polygon(0 0, calc(100% - 16px) 0, 100% 50%, calc(100% - 16px) 100%, 0 100%, 16px 50%)",
          marginLeft: i === 0 ? 0 : -16,
        }}
      >
        {m.year}
      </div>

      <div className="relative flex h-5 w-full items-center justify-center">
        {!isTop && (
          <>
            <span className="absolute top-0 h-5 border-l-2 border-dashed border-[#DA2128]/40" />
            <span className="absolute -top-1 h-3 w-3 rounded-full border-2 border-white bg-[#DA2128] shadow" />
          </>
        )}
      </div>

      <div className="flex h-[185px] w-full items-start justify-center">
        {!isTop && (
          <MilestoneCard m={m} Icon={Icon} position="bottom" animated={animated} />
        )}
      </div>
    </div>
  );
}

/* ---------------- desktop: pinned scroll-jack (LOCK SCROLL — unchanged) ---------------- */
function PinnedRibbon() {
  const wrapperRef = useRef(null);
  const trackRef = useRef(null);
  const [distance, setDistance] = useState(0);

  useLayoutEffect(() => {
    const measure = () => {
      if (!trackRef.current) return;
      const trackWidth = trackRef.current.scrollWidth;
      const viewportWidth = window.innerWidth;
      setDistance(Math.max(trackWidth - viewportWidth, 0));
    };

    measure();

    const ro = new ResizeObserver(measure);
    if (trackRef.current) ro.observe(trackRef.current);
    window.addEventListener("resize", measure);

    return () => {
      ro.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, []);

  const { scrollYProgress } = useScroll({
    target: wrapperRef,
    offset: ["start start", "end end"],
  });

  // Direct 1:1 mapping — no spring lag, track moves exactly with scroll
  const x = useTransform(scrollYProgress, [0, 1], [0, -distance]);
  const progressWidth = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);
  const hintOpacity = useTransform(scrollYProgress, [0, 0.08], [1, 0]);
  const counter = useTransform(scrollYProgress, (v) =>
    String(Math.min(milestones.length, Math.round(v * (milestones.length - 1)) + 1)).padStart(2, "0")
  );

  return (
    <div
      ref={wrapperRef}
      className="relative"
      style={{ height: `calc(100vh + ${distance}px)` }}
    >
      <div className="sticky top-0 h-screen w-full overflow-hidden bg-[#FAF7F2]">
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white via-[#FAF7F2] to-white" />

        {/* Edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 z-20 w-16 bg-gradient-to-r from-[#FAF7F2] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-20 w-16 bg-gradient-to-l from-[#FAF7F2] to-transparent" />

        {/* Top HUD */}
        <div className="pointer-events-none absolute left-0 right-0 top-0 z-30 px-4 pt-6 sm:px-10 md:pt-10">
          <div className="mx-auto flex max-w-7xl flex-col gap-3">
            <div className="flex items-center justify-between">
              <p className="text-[10px] font-bold tracking-[0.25em] text-gray-500 uppercase sm:text-xs">
                ASSOCHAM Milestone{" "}
                {/* <motion.span className="text-[#DA2128]">{counter}</motion.span>
                <span className="text-gray-300"> / {milestones.length}</span> */}
              </p>
              <motion.span
                style={{ opacity: hintOpacity }}
                className="hidden items-center gap-2 text-[10px] font-bold tracking-widest text-gray-400 uppercase sm:flex"
              >
                Keep scrolling
                <FaChevronDown className="text-[#DA2128]" />
              </motion.span>
            </div>
            <div className="h-1 w-full overflow-hidden rounded-full bg-gray-200">
              <motion.div
                style={{ width: progressWidth }}
                className="h-full rounded-full bg-gradient-to-r from-[#DA2128] to-[#F0484E]"
              />
            </div>
          </div>
        </div>

        {/* Horizontal track */}
        <div className="relative flex h-full w-full items-center">
          <motion.div
            ref={trackRef}
            style={{ x, willChange: "transform" }}
            className="flex items-center gap-0 px-6 sm:px-10"
          >
            {milestones.map((m, i) => (
              <TimelineItem key={m.year} m={m} i={i} animated={false} />
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
}

/* ---------------- desktop fallback: STOP → MOVE → STOP auto-scroll ribbon ---------------- */
function AutoScrollRibbon() {
  const containerRef = useRef(null);
  const pausedRef = useRef(false);
  const resumeTimeoutRef = useRef(null);
  const stepTimeoutRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const PAUSE_MS = 1800; // how long it "stops" and holds on each card
    const MOVE_MS = 700; // approx duration of the smooth slide to next card

    const moveNext = () => {
      if (!container) return;

      // if user is interacting, keep checking instead of moving
      if (pausedRef.current) {
        stepTimeoutRef.current = setTimeout(moveNext, 300);
        return;
      }

      const firstChild = container.children[0];
      const itemWidth = firstChild ? firstChild.offsetWidth : 270;
      const maxScroll = container.scrollWidth - container.clientWidth;
      const target = container.scrollLeft + itemWidth;

      if (target >= maxScroll - 5) {
        // reached the end: hold there, then smoothly loop back to start
        container.scrollTo({ left: maxScroll, behavior: "smooth" });
        stepTimeoutRef.current = setTimeout(() => {
          container.scrollTo({ left: 0, behavior: "smooth" });
          stepTimeoutRef.current = setTimeout(moveNext, PAUSE_MS + MOVE_MS);
        }, PAUSE_MS + MOVE_MS);
      } else {
        container.scrollTo({ left: target, behavior: "smooth" });
        stepTimeoutRef.current = setTimeout(moveNext, PAUSE_MS + MOVE_MS);
      }
    };

    stepTimeoutRef.current = setTimeout(moveNext, PAUSE_MS);

    const pause = () => {
      pausedRef.current = true;
      if (resumeTimeoutRef.current) clearTimeout(resumeTimeoutRef.current);
    };
    const resumeLater = () => {
      if (resumeTimeoutRef.current) clearTimeout(resumeTimeoutRef.current);
      resumeTimeoutRef.current = setTimeout(() => {
        pausedRef.current = false;
      }, 1500);
    };

    container.addEventListener("mouseenter", pause);
    container.addEventListener("mouseleave", resumeLater);
    container.addEventListener("touchstart", pause, { passive: true });
    container.addEventListener("touchend", resumeLater, { passive: true });
    container.addEventListener(
      "wheel",
      () => {
        pause();
        resumeLater();
      },
      { passive: true }
    );

    return () => {
      clearTimeout(stepTimeoutRef.current);
      if (resumeTimeoutRef.current) clearTimeout(resumeTimeoutRef.current);
      container.removeEventListener("mouseenter", pause);
      container.removeEventListener("mouseleave", resumeLater);
      container.removeEventListener("touchstart", pause);
      container.removeEventListener("touchend", resumeLater);
    };
  }, []);

  return (
    <div className="relative mx-auto max-w-7xl">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-20 w-16 bg-gradient-to-r from-white to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-20 w-16 bg-gradient-to-l from-white to-transparent" />
      <div
        ref={containerRef}
        className="scrollbar-hide flex overflow-x-auto px-6 py-6 sm:px-10"
        style={{ WebkitOverflowScrolling: "touch" }}
      >
        {milestones.map((m, i) => (
          <TimelineItem key={m.year} m={m} i={i} animated />
        ))}
      </div>
    </div>
  );
}

/* ---------------- mobile: native swipe + STOP → MOVE → STOP auto-scroll ---------------- */
function SwipeRibbon() {
  const containerRef = useRef(null);
  const pausedRef = useRef(false);
  const resumeTimeoutRef = useRef(null);
  const stepTimeoutRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const PAUSE_MS = 2000; // how long it "stops" and holds on each card
    const MOVE_MS = 650; // approx duration of the smooth slide to next card

    const moveNext = () => {
      if (!container) return;

      if (pausedRef.current) {
        stepTimeoutRef.current = setTimeout(moveNext, 300);
        return;
      }

      const firstChild = container.children[0];
      const itemWidth = firstChild ? firstChild.offsetWidth : 230;
      const maxScroll = container.scrollWidth - container.clientWidth;
      const target = container.scrollLeft + itemWidth;

      if (target >= maxScroll - 5) {
        container.scrollTo({ left: maxScroll, behavior: "smooth" });
        stepTimeoutRef.current = setTimeout(() => {
          container.scrollTo({ left: 0, behavior: "smooth" });
          stepTimeoutRef.current = setTimeout(moveNext, PAUSE_MS + MOVE_MS);
        }, PAUSE_MS + MOVE_MS);
      } else {
        container.scrollTo({ left: target, behavior: "smooth" });
        stepTimeoutRef.current = setTimeout(moveNext, PAUSE_MS + MOVE_MS);
      }
    };

    stepTimeoutRef.current = setTimeout(moveNext, PAUSE_MS);

    const pause = () => {
      pausedRef.current = true;
      if (resumeTimeoutRef.current) clearTimeout(resumeTimeoutRef.current);
    };
    const resumeLater = () => {
      if (resumeTimeoutRef.current) clearTimeout(resumeTimeoutRef.current);
      resumeTimeoutRef.current = setTimeout(() => {
        pausedRef.current = false;
      }, 2000);
    };

    container.addEventListener("touchstart", pause, { passive: true });
    container.addEventListener("touchend", resumeLater, { passive: true });
    container.addEventListener("mousedown", pause);
    container.addEventListener("mouseup", resumeLater);

    return () => {
      clearTimeout(stepTimeoutRef.current);
      if (resumeTimeoutRef.current) clearTimeout(resumeTimeoutRef.current);
      container.removeEventListener("touchstart", pause);
      container.removeEventListener("touchend", resumeLater);
      container.removeEventListener("mousedown", pause);
      container.removeEventListener("mouseup", resumeLater);
    };
  }, []);

  return (
    <div className="relative mx-auto max-w-7xl">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-20 w-8 bg-gradient-to-r from-white to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-20 w-8 bg-gradient-to-l from-white to-transparent" />
      <div
        ref={containerRef}
        className="scrollbar-hide flex snap-x snap-mandatory overflow-x-auto scroll-smooth px-4 py-6"
        style={{ WebkitOverflowScrolling: "touch" }}
      >
        {milestones.map((m, i) => (
          <div key={m.year} className="snap-center">
            <TimelineItem m={m} i={i} animated />
          </div>
        ))}
      </div>
    </div>
  );
}

/* ---------------- main export ---------------- */
export default function Milestones() {
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth >= 768 : true
  );

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 768px)");
    const handler = (e) => setIsDesktop(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return (
    <section id="milestones" className="relative bg-white">
      {/* Intro header */}
      <div className="relative mx-auto max-w-7xl px-4 pt-20 sm:px-6 lg:px-8 md:pt-10">
        <div className="text-center">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="mb-3 inline-flex items-center gap-2 rounded-full bg-[#DA2128]/10 px-4 py-1.5 text-xs font-bold tracking-[0.2em] text-[#DA2128] uppercase"
          >
            
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-serif text-4xl font-medium leading-tight tracking-tight sm:text-3xl lg:text-4xl"
          >
            ASSOCHAM {" "}
            <motion.span 
                className="italic text-[#DA2128]"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
            Milestones
            </motion.span>
          </motion.h2>
          <div className="mx-auto mt-4 accent-bar" />
          {/* <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-gray-600 sm:text-base">
            {isDesktop
              ? "Scroll through the next section — it glides horizontally through 100+ years of legacy, from Royal Exchange Calcutta (1920) to Chanakyapuri, New Delhi."
              : "Swipe sideways through 100+ years of legacy, from Royal Exchange Calcutta (1920) to Chanakyapuri, New Delhi."}
          </p> */}

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="mt-6 inline-flex items-center gap-2 text-[11px] font-semibold tracking-widest text-gray-400 uppercase"
          >
            {isDesktop ? "Keep scrolling to begin" : "Swipe to explore"}
            {isDesktop ? (
              <motion.span
                animate={{ y: [0, 6, 0] }}
                transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
              >
                <FaChevronDown className="text-[#DA2128]" />
              </motion.span>
            ) : (
              <motion.span
                animate={{ x: [0, 6, 0] }}
                transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
              >
                <FaArrowRight className="text-[#DA2128]" />
              </motion.span>
            )}
          </motion.div>
        </div>
      </div>

      <div className="mt-10 sm:mt-14">
        {isDesktop ? (
          SCREEN_LOCK_ANIMATION === 1 ? <PinnedRibbon /> : <AutoScrollRibbon />
        ) : (
          <SwipeRibbon />
        )}
      </div>

      {/* Stats footer */}
      <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mx-auto max-w-4xl text-center"
        >
          {/* stats block unchanged / commented out as before */}
        </motion.div>
      </div>
    </section>
  );
}